import cn from "classnames";
import { createForm } from "rc-form";
import React, { FormEvent, FunctionComponent, useState } from "react";

import Button from "@/apps/ui/components/Button";
import Input from "@/apps/ui/components/Input";
import Label from "@/apps/ui/components/Label";

import { loadCampaigns } from "../../store/campaigns/actions";

import styleCss from "./style.css";

interface FormProps {
  form: any;
  isLoading: boolean;
  loadCampaigns: typeof loadCampaigns;
}

const Form: FunctionComponent<FormProps> = function ({
  form: { getFieldDecorator, validateFields, getFieldError },
  loadCampaigns,
  isLoading,
}) {
  const [isTrySubmit, setIsTrySubmited] = useState(false);

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsTrySubmited(true);

    validateFields((errors: any, values: any) => {
      if (errors) return;
      loadCampaigns(values.vin);
    });
  }

  function getError(field: string) {
    return isTrySubmit && getFieldError(field);
  }

  return (
    <form className={styleCss.form} onSubmit={submit}>
      <Label>ВВЕДИТЕ VIN</Label>
      {getFieldDecorator("vin", {
        rules: [
          { required: true, message: "Укажите VIN" },
          { len: 17, message: "Длина VIN должна быть ровно 17 символов" },
        ],
        initialValue: "",
      })(<Input placeholder="Например, JS1CY111100107000" className={styleCss.search} error={getError("vin")} />)}
      <Button type="submit" icon="arrow" className={cn(styleCss["btn-primary-service"])} disabled={isLoading}>
        Найти
      </Button>
    </form>
  );
};

export default createForm()(Form);
